var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconChevronLeft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 300 300",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M180 236.9a9.1 9.1 0 01-7.2-3.5L108.6 149l64.3-82.4a9 9 0 1114.2 11l-55.7 71.5 55.8 73.4a9 9 0 01-7.2 14.4z"
  })));
}
export default SvgIconChevronLeft;